import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit {
    // @Input('tabTitle') title: string = '';
    @Input('tabTitle') title: any;
    @Input('number') number: any = false;
    @Input('svg') svg: boolean = false;
    @Input('numberAfter') numberAfter: number = 0;
    @Input('type') type: string = 'success';
    @Input('counterBadge') counterBadge: number = 0;

    @Input() showBlockedIcon: boolean | number = false;
    @Input() active = false;
    @Input() navClass = '';
    @Input() groupId = 0;
    @Input() time ='';


    constructor() {
    }

    ngOnInit() {

    }


}
